import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import configData from './sso_config.json';

let redirect_Uri = '';
let REACT_APP_AZURE_AD_FUNCAPP_CLIENTID = '';
const runEnv = process.env.REACT_APP_RUN_ENV;
if (!runEnv) {
  throw new Error("REACT_APP_RUN_ENV is not defined");
}
// Redirect URL
if(runEnv === 'local') {
    redirect_Uri = configData.LOCAL_REDIRECT_URI;
    REACT_APP_AZURE_AD_FUNCAPP_CLIENTID = process.env.REACT_APP_AZURE_AD_FUNCAPP_CLIENTID_QE;
} else if(runEnv === 'qe') {
    redirect_Uri = configData.QE_REDIRECT_URI;
    REACT_APP_AZURE_AD_FUNCAPP_CLIENTID = process.env.REACT_APP_AZURE_AD_FUNCAPP_CLIENTID_QE;
} else {
    redirect_Uri = configData.PROD_REDIRECT_URI;
    REACT_APP_AZURE_AD_FUNCAPP_CLIENTID = process.env.REACT_APP_AZURE_AD_FUNCAPP_CLIENTID;
}

console.log("redirect uri",redirect_Uri);
console.log("env",runEnv);
console.log(process.env);
const REACT_APP_AZURE_AD_CLIENTID = process.env.REACT_APP_AZURE_AD_CLIENTID;
const REACT_APP_AZURE_AD_TENANTID = process.env.REACT_APP_AZURE_AD_TENANTID;
//const REACT_APP_AZURE_AD_FUNCAPP_CLIENTID = process.env.REACT_APP_AZURE_AD_FUNCAPP_CLIENTID;

if (!REACT_APP_AZURE_AD_CLIENTID || !REACT_APP_AZURE_AD_TENANTID) {
    throw new Error("Azure AD Client ID or Tenant ID is not defined in environment variables.");
  }

console.log("Client ID:", REACT_APP_AZURE_AD_CLIENTID);
console.log("Tenant ID:", REACT_APP_AZURE_AD_TENANTID);
console.log("Function App Client ID:", REACT_APP_AZURE_AD_FUNCAPP_CLIENTID);
export const msalConfig = {
  auth: {
    clientId: REACT_APP_AZURE_AD_CLIENTID, // Replace with your Azure AD Application (client) ID
    authority: "https://login.microsoftonline.com/" + REACT_APP_AZURE_AD_TENANTID, // Replace with your Azure AD Tenant ID
    redirectUri: redirect_Uri, // Redirect URI after login
    postLogoutRedirectUri: "/atsg/home"
  },
  cache: {
    cacheLocation: "localStorage", // Cache location
    storeAuthStateInCookie: true, // Recommended for IE11 or Edge
  },
  system: {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {	
                return;	
            }
            switch (level) {	
                case LogLevel.Error:	
                    console.error(message);	
                    return;	
                case LogLevel.Info:	
                    console.info(message);	
                    return;	
                case LogLevel.Verbose:	
                    console.debug(message);	
                    return;	
                case LogLevel.Warning:	
                    console.warn(message);	
                    return;	
                default:
                    return;
            }
        }
    }
}
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: [`api://${REACT_APP_AZURE_AD_CLIENTID}/access_via_group_assignments`]
};

export const functionAppLoginRequest = {
  scopes: [`api://${REACT_APP_AZURE_AD_FUNCAPP_CLIENTID}/user_impersonation`]
};


// Group IDs to allow Authorization.
export const groups = {
    EsOps: '1d2e375c-6310-4d18-9d2d-58a29ca063af',
  //  CrestronSupportGroup: 'c1a3f0d2-5f3a-4d7c-9c58-974c0d76c1aa',
  //  DevOps_Automation_Users: '43319c9c-aca4-45d4-bc17-5c878ab5fd17',
    XioSupportToolsAtsgRW: 'dbf1f4f7-c0bb-4b5c-b72b-7dd1772678c7',
    XioSupportToolsAtsgRO: '53e5e5bf-e7a9-4029-b89f-cbc5a3b27a58',
    XioSupportToolsAtsgAdmin: '18b93131-6c3a-44f9-8aee-a58b13bf3a01'
};


//export const msalInstance = new PublicClientApplication(msalConfig);
//await msalInstance.initialize();

export const CACHE_TTL_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds